var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ScopeNode, ScopeService } from './scope.service';
var ScopeComponent = /** @class */ (function (_super) {
    __extends(ScopeComponent, _super);
    function ScopeComponent(router, route, logger, action, message, page, service, renderer) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.renderer = renderer;
        _this.defMode = '';
        _this.scopeMode = '';
        _this.scopeData = new Scope();
        _this.scopeDisp = true;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            'show_contextmenu.jstree',
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'wholerow',
            'checkbox',
            'search',
            'types'
        ];
        _this.limit = 10;
        _this.search = false;
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        _this.toggle = false;
        return _this;
    }
    ScopeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.limit) {
            this.limit = this.component.params.limit;
        }
    };
    ScopeComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    ScopeComponent.prototype.init = function () {
        var self = this;
        this.tree_data.subscribe(function (data) {
            var coreData = function ($node, cb) {
                if ($node.id === '#') {
                    cb(data);
                }
                else {
                    var load_data = self.onLoadNode($node);
                    cb(load_data);
                }
            };
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: true,
                        data: coreData,
                        themes: {
                            icons: false
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        three_state: false
                    },
                    search: {
                        show_only_matches: true
                    },
                    types: {
                        more: {
                            valid_children: []
                        }
                    },
                    plugins: self.plugins
                });
            }
            else {
                tree.settings.core.data = coreData;
                tree.redraw(true);
                tree.refresh(true, true);
            }
        });
        var events = this.all_events.filter(function (element) {
            return self.ignore_events.indexOf(element) == -1;
        });
        $(this.element).on(events.join(' '), function (e, data) {
            self.onEvent(e, e.type, data);
        });
    };
    ScopeComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        var mode = jsonpath.value(this.component, '$.params.mode');
        if (typeof mode !== 'undefined') {
            this.defMode = mode;
        }
        var scopeMode = jsonpath.value(this.component, '$.params.scopeMode');
        if (typeof scopeMode !== 'undefined') {
            this.scopeMode = scopeMode;
        }
    };
    ScopeComponent.prototype.setChangeCompData = function (component) {
        var units = jsonpath.value(component, '$.params.units');
        if (typeof units !== 'undefined') {
            this.scopeDisp = true;
            this.org_data = units;
        }
        else {
            this.scopeDisp = false;
            this.renderer.setStyle(this.scopeElement.nativeElement, 'display', 'none');
        }
    };
    ScopeComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ScopeComponent.prototype.onModeSubscribe = function (mode) {
        if (typeof this.org_data !== 'undefined' && this.org_data instanceof Array) {
            this.onSearchClear();
        }
        if (mode !== 'entry' && mode !== 'confirm' && this.defMode !== '' && this.defMode !== mode) {
            this.action.deleteCompRec(this.componentName);
        }
    };
    ScopeComponent.prototype.onSubscribe = function (rec) {
        if (!this.scopeDisp) {
            return;
        }
        this.scopeData.scope = false;
        if (this.scopeMode === 'entry') {
            this.scopeData.units = jsonpath.query(this.org_data, '$..[?(@.grant==true)]').map(function (value) {
                return value.label;
            });
            this.scopeData.units_label = this.getLabel(this.scopeData.units.length);
        }
        else if (this.scopeMode === 'view' && typeof rec.unit_m !== 'undefined' && rec.unit_m instanceof Array) {
            var units = [];
            var unit_w = void 0;
            for (var _i = 0, _a = rec.unit_m; _i < _a.length; _i++) {
                var unit = _a[_i];
                if (unit.access.match(/w/)) {
                    unit_w = unit.unit_m.id;
                }
                units.push(unit.unit_m.id);
            }
            if (units.length > 1) {
                this.scopeData.scope = true;
            }
            var tree = jsonpath.value(this.org_data, '$..[?(@.id==' + unit_w + ')]');
            var data = tree ? [tree] : this.org_data;
            this.setChecked(data, units);
            this.scopeData.units = jsonpath.query(data, '$..[?(@.grant==true)]').map(function (value) {
                return value.label;
            });
            this.scopeData.units_label = this.getLabel(units.length);
            this.org_data = data;
        }
        this.onSearchClear();
        if (typeof rec['$scope'] !== 'undefined') {
            this.scopeData.scope = rec['$scope'];
        }
        if (this.scopeMode === 'entry') {
            this.action.setCompRec(this.componentName, { $scope: this.scopeData.scope });
        }
    };
    ScopeComponent.prototype.getLabel = function (count) {
        return this.msgSnapshot['ScopeComponent.label.units'].replace(/\{\{count\}\}/, count.toString());
    };
    ScopeComponent.prototype.setChecked = function (data, units) {
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var d = data_1[_i];
            if (units.indexOf(d.id) >= 0) {
                d.grant = true;
            }
            else {
                d.grant = false;
            }
            if (d.children) {
                this.setChecked(d.children, units);
            }
        }
    };
    ScopeComponent.prototype.applyToTreeData = function (recs) {
        if (!this.element) {
            this.element = this.treeElement.nativeElement;
            this.init();
        }
        this.is_control_tree_monitor = true;
        this.tree_data.next(this.createTreeData(recs));
        this.is_control_tree_monitor = false;
    };
    ScopeComponent.prototype.createTreeData = function (recs) {
        var data = [];
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            data.push(new UnitNode(rec, this.search));
            if (data.length == this.limit && this.limit < recs.length && !this.search) {
                data.push(this.createMoreNode());
                break;
            }
        }
        return data;
    };
    ScopeComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'select_node') {
            if (rec.node.type === 'more' && rec.event.type === 'click') {
                this.onMoreNode(rec);
            }
        }
        else if (e2 === 'load_node') {
            if (this.search) {
                this.search = false;
                this.tree().search(this.treeSearch);
            }
        }
    };
    ScopeComponent.prototype.onLoadNode = function (rec) {
        var recs = jsonpath.value(this.org_data, '$..[?(@.id==' + rec.id + ')]');
        recs = recs.children;
        return this.createTreeData(recs);
    };
    ScopeComponent.prototype.onMoreNode = function (rec) {
        var node = rec.node;
        var parent_node = this.tree().get_node(node.parent);
        var scrollTop = $(window).scrollTop();
        var page = node.data.page;
        var offset = page * this.limit;
        var recs = (node.parent === '#' ? this.org_data : jsonpath.value(this.org_data, '$..[?(@.id==' + node.parent + ')]').children);
        var count = 0;
        this.tree().delete_node(node);
        for (var i = offset; i < recs.length; i++) {
            this.tree().create_node(parent_node, new UnitNode(recs[i], this.search));
            count++;
            if (count == this.limit && offset + this.limit < recs.length && !this.search) {
                this.tree().create_node(parent_node, this.createMoreNode(page + 1));
                break;
            }
        }
        $(window).scrollTop(scrollTop);
    };
    ScopeComponent.prototype.createMoreNode = function (page) {
        if (page === void 0) { page = 1; }
        return new UnitNode({ more: true, page: page }, this.search, this.msgSnapshot);
    };
    ScopeComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
    };
    ScopeComponent.prototype.onSearch = function () {
        if (!this.treeSearch) {
            return;
        }
        this.search = true;
        this.applyToTreeData(this.org_data);
    };
    ScopeComponent.prototype.onSearchClear = function () {
        this.search = false;
        this.treeSearch = '';
        if (this.tree()) {
            this.tree().clear_search();
        }
        this.applyToTreeData(this.org_data);
    };
    ScopeComponent.prototype.onChangeScope = function () {
        this.scopeData.scope = !this.scopeData.scope;
        this.toggle = false;
        this.action.setCompRec(this.componentName, { $scope: this.scopeData.scope });
        this.action.firstAction('scope_' + this.scopeData.scope.toString());
    };
    ScopeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
    };
    ScopeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'scope',
                    template: "<div id=\"{{ componentName }}\" [key]=\"'grid'\" [type]=\"'row'\" [comp]=\"component\" gridDir #scope>\n  <div [key]=\"'grid'\" [type]=\"'col'\" [comp]=\"component\" gridDir>\n    <form>\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['ScopeComponent.label.title']}\" [msg]=\"msg\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\">\n          <ul>\n            <li class=\"form_li form_li-w100per\">\n              <ng-template [ngIf]=\"scopeMode === 'entry' && mode !== 'confirm'\">\n                <input class=\"switchInput\" id=\"scopeSwitch\" type=\"checkbox\" [checked]=\"scopeData.scope\" (change)=\"onChangeScope()\">\n                <label class=\"switchInput_btn\" for=\"scopeSwitch\">\n                  <span class=\"switchInput_description\">{{ (msg | async)['ScopeComponent.checkbox.unchecked'] }}</span>\n                  <span class=\"switchInput_description switchInput_description-checked\">{{ (msg | async)['ScopeComponent.checkbox.checked'] }}</span>\n                </label>\n              </ng-template>\n              <p [hidden]=\"scopeData.scope\" class=\"switchInput_current\" [class.-mt-2]=\"scopeMode === 'entry' && mode !== 'confirm'\">{{ (msg | async)['ScopeComponent.label.currentunit'] }}: {{ scopeData.units ? scopeData.units[0] : '' }}</p>\n              <div [hidden]=\"!scopeData.scope\" class=\"filter switchInput_filter\" [class.-mt-2]=\"scopeMode === 'entry' && mode !== 'confirm'\">\n                <p class=\"filter_trigger\">\n                  <span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ scopeData.units_label }}</span>\n                </p>\n                <div class=\"filter_property filter_property_toggle -p-2\" [style.display]=\"toggle ? 'block': 'none'\">\n                  <div class=\"row\">\n                    <div class=\"col-sm-12\">\n                      <ul [key]=\"'btn'\" buttonDir>\n                        <li [key]=\"'btn'\" buttonDir>\n                          <input type=\"text\" class=\"checkTree_searchInput\" placeholder=\"{{ (msg | async)['Search...'] }}\" name=\"treeSearch\" [(ngModel)]=\"treeSearch\">\n                        </li>\n                        <li [key]=\"'btn'\" buttonDir>\n                          <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#search',\n                                    caption: (msg | async)['SearchConditionComponent.button.search'],\n                                    params: {btnClass: {sm: true}}\n                                }\" (clickBtn)=\"onSearch()\"></item-btn>\n                        </li>\n                        <li [key]=\"'btn'\" buttonDir>\n                          <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#searchClear',\n                                    caption: (msg | async)['SearchConditionComponent.button.clear'],\n                                    params: {btnClass: {sm: true, type: 'delete'}}\n                                }\" (clickBtn)=\"onSearchClear()\"></item-btn>\n                        </li>\n                      </ul>\n                      <div #tree></div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </form>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    ScopeComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ScopeService },
        { type: Renderer2 }
    ]; };
    ScopeComponent.propDecorators = {
        scopeElement: [{ type: ViewChild, args: ['scope',] }],
        treeElement: [{ type: ViewChild, args: ['tree',] }]
    };
    return ScopeComponent;
}(ContentBaseComponent));
export { ScopeComponent };
var UnitNode = /** @class */ (function (_super) {
    __extends(UnitNode, _super);
    function UnitNode(rec, search, msg) {
        if (msg === void 0) { msg = {}; }
        var _this = _super.call(this, rec) || this;
        if (rec['id'] != null) {
            _this.id = rec.id;
        }
        if (rec['grant'] != null) {
            _this.state.checked = rec.grant;
        }
        if (rec['disable'] != null && rec['disable']) {
            _this.a_attr.class = 'checkTree_disabled';
        }
        if (rec != null) {
            if (rec['children'] != null) {
                if (search) {
                    _this.children = [];
                    for (var _i = 0, _a = rec['children']; _i < _a.length; _i++) {
                        var child = _a[_i];
                        _this.children.push(new UnitNode(child, search));
                    }
                }
                else if (rec['children'].length > 0) {
                    _this.children = true;
                }
            }
        }
        if (rec['more']) {
            _this.text = '<a href="javascript:void(0);">' + msg['au.COMPONENTS.label.tree.more'] + '</a>';
            _this.type = 'more';
            _this.li_attr.class = 'checkTree_more';
        }
        else {
            _this.state.disabled = true;
        }
        return _this;
    }
    return UnitNode;
}(ScopeNode));
var Scope = /** @class */ (function () {
    function Scope() {
    }
    return Scope;
}());
//# sourceMappingURL=scope.component.js.map